import React, { useEffect, useState } from 'react';
import { Copy } from 'lucide-react';
import Modal from './Modal';

// When the server has no email service, an invite or set-password link is
// not delivered. The server hands the link back instead, so the admin can
// send it themselves. These show it with a Copy button.

export function InviteLinkField({ url, id = 'invite-link' }) {
  const [note, setNote] = useState('');

  useEffect(() => { setNote(''); }, [url]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setNote('Copied to the clipboard.');
    } catch (err) {
      setNote('Could not copy. Select the link and copy it instead.');
    }
  };

  return (
    <div className="form-group" style={{ marginBottom: 0 }}>
      <label className="form-label" htmlFor={id}>Link</label>
      <div style={{ display: 'flex', gap: '8px' }}>
        <input
          id={id}
          type="text"
          className="form-input"
          value={url}
          readOnly
          onFocus={(e) => e.target.select()}
          style={{ fontFamily: 'monospace', fontSize: '13px' }}
        />
        <button type="button" className="btn btn-secondary" onClick={copy}><Copy size={16} /> Copy</button>
      </div>
      {note && <p role="status" style={{ fontSize: '13px', color: 'var(--text-secondary)', margin: '8px 0 0' }}>{note}</p>}
    </div>
  );
}

// result: { url, name, email, kind } where kind is 'invite' or 'reset'.
export default function InviteLinkDialog({ result, onClose }) {
  const isReset = result?.kind === 'reset';
  const who = result?.name || result?.email || 'this person';
  return (
    <Modal isOpen={!!result?.url} onClose={onClose} title={isReset ? 'Copy the set-password link' : 'Copy the invite link'}>
      {result?.url && (
        <>
          <div className="modal-body">
            <div className="alert alert-warning">
              Email isn't set up on this server yet, so nothing was sent.
            </div>
            <p style={{ marginTop: 0 }}>
              Send this link to {who}{result.email && result.name ? ` (${result.email})` : ''} yourself.
              {isReset
                ? ' It lets them choose a new password.'
                : ' It lets them set a password and sign in.'}
              {' '}It works once and expires after a while.
            </p>
            <InviteLinkField url={result.url} />
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary" onClick={onClose}>Done</button>
          </div>
        </>
      )}
    </Modal>
  );
}
